module.exports = __webpack_public_path__ + "static/media/update.5b4c821b.svg";